import ClickableLink from 'components/Common/Clickable/ClickableLink'
import Label from 'LuxKit/Label/Label'
import NoPlaceLikeHomeCampaignIcon from 'components/Common/Labels/NoPlaceLikeHomeCampaignIcon'
import { NO_PLACE_LIKE_HOME_CAMPAIGN_PATH } from 'home/constants/onlyInAustraliaHeroCampaign'
import { useCallback, type MouseEvent } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const CAMPAIGN_LABEL_BACKGROUND = '#FBE4DC'
const CAMPAIGN_LABEL_FOREGROUND = '#363A45'

const CampaignLabel = styled(Label)`
  cursor: pointer;

  &&.kind-primary.variant-highlight {
    background-color: ${CAMPAIGN_LABEL_BACKGROUND};
    border-color: ${CAMPAIGN_LABEL_BACKGROUND};
    color: ${CAMPAIGN_LABEL_FOREGROUND};
  }
`

function TheresNoPlaceLikeHomeCampaignLabel() {
  const intl = useIntl()
  const onClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()
  }, [])

  return <ClickableLink to={NO_PLACE_LIKE_HOME_CAMPAIGN_PATH} onClick={onClick}>
    <CampaignLabel
      kind="primary"
      variant="highlight"
      startIcon={<NoPlaceLikeHomeCampaignIcon />}
    >
      {intl.formatMessage({
        id: '4jdo6tNXblIcopMFFT9S',
        defaultMessage: 'There’s no place like home',
        description: 'Campaign label shown on offers tagged for the There is no place like home marketing campaign.',
      })}
    </CampaignLabel>
  </ClickableLink>
}

export default TheresNoPlaceLikeHomeCampaignLabel
